/**
 * Voting Poll types for the nomination voting system
 */

export enum VotingPollStatus {
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
}

export interface VotingPoll {
  id: string;
  title: string;
  description?: string;
  createdBy: string;
  createdByName: string;
  status: VotingPollStatus;
  nominees: string[];
  nomineeNames: string[];
  voters: string[];
  voterNames: string[];
  deadline?: string;
  createdAt: string;
  updatedAt: string;
}

export interface Vote {
  pollId: string;
  voterId: string;
  voterName: string;
  nomineeId: string;
  nomineeName: string;
  createdAt: string;
}

export interface VotingResult {
  nomineeId: string;
  nomineeName: string;
  voteCount: number;
}

export interface CreateVotingPollInput {
  title: string;
  description?: string;
  nominees: string[];
  nomineeNames: string[];
  voters: string[];
  voterNames: string[];
  deadline?: string;
}

export interface CastVoteInput {
  pollId: string;
  nomineeId: string;
  nomineeName: string;
}
